// src/components/strumenti/RitenutaAcconto.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function RitenutaAcconto() {
  const [compenso, setCompenso] = useState("");
  const [aliquota, setAliquota] = useState("20");

  const C = leggiNumero(compenso)||0;
  const al = leggiNumero(aliquota)||0;
  const ritenuta = C*(al/100);
  const netto = C-ritenuta;

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>Compenso professionale lordo (€)</label>
          <input value={compenso} onChange={e=>setCompenso(e.target.value)} style={inp} placeholder="Es. 1000"/>
        </div>
        <div>
          <label style={lbl}>Aliquota ritenuta (%)</label>
          <input value={aliquota} onChange={e=>setAliquota(e.target.value)} style={inp}/>
        </div>
      </div>

      <div style={{ background:"#ecfdf5", border:"1px solid #a7f3d0", borderRadius:10, padding:"14px 16px" }}>
        <div style={{ display:"flex", justifyContent:"space-around" }}>
          <div style={{textAlign:"center"}}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600 }}>Ritenuta ({aliquota}%)</div>
            <div style={{ fontSize:20, fontWeight:700, color:"#374151" }}>{C>0 ? ritenuta.toLocaleString("it-IT",{minimumFractionDigits:2,maximumFractionDigits:2}) : "—"} €</div>
          </div>
          <div style={{textAlign:"center"}}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600 }}>Netto a pagare</div>
            <div style={{ fontSize:22, fontWeight:800, color:"#059669" }}>{C>0 ? netto.toLocaleString("it-IT",{minimumFractionDigits:2,maximumFractionDigits:2}) : "—"} €</div>
          </div>
        </div>
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Calcolo standard sul compenso lordo — non considera casi particolari (regime forfettario, cassa previdenziale in fattura, ecc.).
      </div>

      <button onClick={()=>{setCompenso("");setAliquota("20");}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
